var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row justify-content-center" }, [
    _vm.profile
      ? _c(
          "div",
          {
            staticClass: "form-container d-flex flex-column align-items-center",
          },
          [
            _c("h2", { staticClass: "title-text mx-auto" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("title.editMail")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "ValidationObserver",
              { ref: "mailObserver" },
              [
                _c(
                  "form",
                  { attrs: { id: "changeMail" } },
                  [
                    _c("v-input", {
                      staticClass: "input-w-default mb-0 mt-2",
                      attrs: {
                        ind: "0",
                        type: "text",
                        placeholder: _vm.$t("placeholder.email"),
                        icon: _vm.$getInputIcon(_vm.mail, "email"),
                        debounce: 500,
                        rules: "required|email|emailNotExists",
                      },
                      model: {
                        value: _vm.mail,
                        callback: function ($$v) {
                          _vm.mail = $$v
                        },
                        expression: "mail",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "center-element change-button",
                    on: { click: _vm.changeMail },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("button.save")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }